import { useState } from "react";
import { ModalDialog } from "../../common/components/dialogs";
import { CrudDialog } from "../../common/components/dialogs/CrudDialog";
import { UserModel } from "../models";
import { EditUser } from "./EditUser";

export const EditUserDialog = ({ user, mode, onUpdate, onDelete, onClose }: { user: UserModel; mode: "view" | "edit" | "add"; onUpdate: (user: UserModel) => void; onDelete?: () => void; onClose: () => void }) => {
  const [editingUser, setEditingUser] = useState<UserModel>(user);
  const [readonly, setReadonly] = useState<boolean>(mode !== "add");

  return mode === "view" ? (
    <ModalDialog flex visible onClose={onClose}>
      <EditUser user={editingUser} onSetUser={setEditingUser} mode={"view"}/>
    </ModalDialog>
  ) : (
    <CrudDialog
      mode={mode === "edit" ? "view" : "edit"}
      onAction={(action) => {
        console.log("ACTION", action)
        if (action === "close") {
          onClose();
        } else if (action === "create" || action === "update") {
          onUpdate(editingUser);
        } else if (action === "delete" && onDelete) {
          onDelete();
        } else if (action === "editOn") {
          setReadonly(false);
        } else if (action === "editOff") {
          setEditingUser(user);
          setReadonly(true);
        }
      }}
    >
      <EditUser user={editingUser} onSetUser={setEditingUser} mode={readonly ? "view" : mode} />
    </CrudDialog>
  );
};
